import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgFileSelectDirective, NgFileDropDirective } from '../_directives/primeng-uploader.component.';

/**
 * Module that provides ngx-uploader API compatibility using native file upload
 * This replaces NgxUploaderModule while maintaining the same API
 */
@NgModule({
  declarations: [
        NgFileSelectDirective,
        NgFileDropDirective
    ],
    exports: [
    NgFileSelectDirective,
    NgFileDropDirective
  ],
  imports: [
    CommonModule
  ], providers: [provideHttpClient(withInterceptorsFromDi())
  ]
})
export class NgxUploaderCompatModule { }

// Re-export types for convenience
export * from '../_models/primeng-uploads';
export * from '../_directives/primeng-uploader.component.';
